import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Repository } from '../../repository/repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketService extends Repository{

  constructor(private http: HttpClient) { 
    super(http);
    this.apiURL += '/eco/tickets';
  }

  /**
   * @deprecated The x-token is now attached by AuthTokenInterceptor.
   * This getter is kept only for backward compatibility with callers that
   * spread `this.headers` or access `this.headers.headers`. The headers
   * object is intentionally empty — the token is added by the interceptor.
   */
  get headers() {
    return { headers: {} };
  }
  
  getTickets( data?: any ) {
    return this.http.get(`${ this.apiURL }`, this.headers);
  }

  createTicket(entity: Object):  Observable<any>  {
    const entityJson = JSON.stringify(entity);
    return this.http.post<any>(`${this.apiURL}`, entityJson, this.resHeaders);
  }

}
